import { downloadVideo } from "./downloadVideo"
import { filename } from "./filename"

export async function shareVideo(urlHash, cachedBlob = null) {
  const videoUrl = `https://holobooth.hypervsn.com/video/${urlHash}.mp4`

  try {
    const isAndroid = /Android/.test(navigator.userAgent)
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream

    // If navigator.share not available -> fallback to download
    if (!navigator.share) {
      console.log("⚠️ Share not supported - downloading instead")
      await downloadVideo(cachedBlob, videoUrl)
      return
    }

    // If Android: download first, then continue to share
    if (isAndroid) {
      console.log("Android device detected - downloading before share")
      await downloadVideo(cachedBlob, videoUrl)
      // continue to attempt navigator.share after download
    } else if (!isIOS) {
      // Non-iOS and non-Android devices fallback to download
      console.log("Not an iOS/Android device - downloading instead")
      await downloadVideo(cachedBlob, videoUrl)
      return
    }

    let blob
    if (cachedBlob) {
      blob = cachedBlob
    } else {
      const response = await fetch(videoUrl)
      blob = await response.blob()
    }

    const file = new File([blob], filename(), {
      type: "video/mp4",
    })

    console.log("Open Share Window")
    await navigator.share({
      title: "My HYPERVSN Experience",
      text: "Check out my HYPERVSN holographic experience!",
      files: [file],
    })
  } catch (error) {
    if (
      error?.name === "AbortError" ||
      (error?.message || "").includes("canceled")
    ) {
      console.log("🟡 Share canceled")
      return
    }
    console.error("Error sharing:", error)
    await downloadVideo(cachedBlob, videoUrl)
  }
}
